import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/fleet/')({
  beforeLoad: (): void => {
    throw redirect({ to: '/settings/fleet/energy-sources' });
  },
});
